import {
  LayoutMode, AvatarShape, FontFamily, FontSize, BorderRadius
} from '../catalogs/pageCatalog.generated.js';

export function normalizeSiteConfig(formValues) {
  const {
    layoutMode = LayoutMode.Continuous,
    seo = {},
    identity = {},
    customStyles = {},
    scope = {},
    blocks = [],
  } = formValues;

  return {
    schemaVersion: 3,
    layoutMode,
    seo: {
      title: seo.title ?? null,
      description: seo.description ?? null,
      ogImageUrl: seo.ogImageUrl ?? null,
    },
    identity: {
      avatarUrl: identity.avatarUrl ?? null,
      avatarShape: identity.avatarShape ?? AvatarShape.Round,
    },
    customStyles: {
      primaryColor: customStyles.primaryColor ?? null,
      backgroundColor: customStyles.backgroundColor ?? null,
      textColor: customStyles.textColor ?? null,
      accentColor: customStyles.accentColor ?? null,
      buttonBackground: customStyles.buttonBackground ?? null,
      fontFamily: customStyles.fontFamily ?? FontFamily.Inter,
      fontSize: customStyles.fontSize ?? FontSize.Medium,
      borderRadius: customStyles.borderRadius ?? BorderRadius.Soft,
    },
    scope: {
      professionalId: scope.professionalId ?? null,
      placeId: scope.placeId ?? null,
    },
    blocks: blocks.map((block) => ({
      id: block.id,
      type: block.type,
      enabled: block.enabled ?? true,
      order: block.order ?? 0,
      config: block.config ?? {},
    })),
  };
}

export default normalizeSiteConfig;
